export function PluginErrorPage() {
  return <p>이 화면을 그리다 문제가 생겼어요. 다른 화면은 그대로 쓸 수 있어요.</p>;
}
